import { fromAxiosNutsJson, webstore } from '@/api';
import { ShopPayPaymentRequest, ShopPayPaymentRequestSessionCreate } from '@/types/shopify';

export async function createSession(
  paymentRequest: ShopPayPaymentRequest,
  sourceIdentifier: string,
) {
  return fromAxiosNutsJson<ShopPayPaymentRequestSessionCreate>(
    webstore.sessionSpecific.post('/api/shopify/session', { paymentRequest, sourceIdentifier }),
    {},
  );
}

export default {};
